import React, { Component } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { getSellsByDay } from "../../../../store/dashboard/actions";
import { Bar } from "react-chartjs-2";
import * as charts from "./_charts";
import {
  selectorChart,
  formatHelper,
  selectHelper,
} from "../../../../common/helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Row,
  Col,
  Label,
  Alert,
  Button,
} from "reactstrap";
import { months, layout } from "../../../../common/constants";
import Select from "react-select";
import { ExportCSV } from "../../../../components";
import { getSellsByDay as salesByDayExport } from "../../../../service/dashboard";
import { roles, messages } from "../../../../common/constants";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { exportExcel } from "./excel";

class CardSellsByDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSellsByDay: true,
      selectedMonth: null,
      selectedYear: null,
      showChart: false,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainSalesExport = this.handleObtainSalesExport.bind(this);

    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value, reset = false) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (!this.state.selectedMonth || !this.state.selectedYear) return;
    await this.setState({ showChart: true });
    this.props.getSellsByDay({
      month: this.state.selectedMonth.value,
      year: this.state.selectedYear.value,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  async handleMonthChange(value, reset = false) {
    await this.setState({ selectedMonth: value });

    if (!this.state.selectedMonth || !this.state.selectedYear) return;
    await this.setState({ showChart: true });
    this.props.getSellsByDay({
      month: this.state.selectedMonth.value,
      year: this.state.selectedYear.value,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async handleYearChange(value, reset = false) {
    await this.setState({ selectedYear: value });

    if (!this.state.selectedMonth || !this.state.selectedYear) return;
    await this.setState({ showChart: true });
    this.props.getSellsByDay({
      month: this.state.selectedMonth.value,
      year: this.state.selectedYear.value,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  handleObtainSalesExport() {
    this.setState({ loadingExport: true });
    const { selectedStore, selectedYear, selectedMonth } = this.state;
    salesByDayExport(
      selectedMonth.value,
      selectedYear.value,
      selectedStore.value
    ).then((response) => {
      exportExcel(
        response.data.data,
        selectedStore,
        selectedYear.value,
        selectedMonth.value
      );
      this.setState({ loadingExport: false });
    });
  }

  render() {
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showSellsByDay: !this.state.showSellsByDay })
          }
        >
          Ventas Días - Mes
        </CardHeader>
        <Collapse isOpen={this.state.showSellsByDay}>
          <CardBody>
            <Row className="mb-2">
              <Col md="3">
                <Row>
                  <Col md="4">
                    <Label className="mt-2">MES:</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder="MES"
                      options={this.props._months}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleMonthChange}
                      value={this.state.selectedMonth}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="3">
                <Row>
                  <Col md="4">
                    <Label className="mt-2">AÑO:</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder="AÑO"
                      options={this.props.years}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleYearChange}
                      value={this.state.selectedYear}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="3">
                {(this.props.role == roles.SUPER_ADMIN ||
                  this.props.role == roles.ADMIN) && (
                  <Row>
                    <Col md="4">
                      <Label className="mt-2">TIENDA:</Label>
                    </Col>

                    <Col md="8">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isLoading={this.props.loadingStores}
                        isSearchable={true}
                        noOptionsMessage={() => {
                          return messages.SELECT_NO_OPTIONS;
                        }}
                        placeholder=""
                        options={this.props.stores}
                        loadingMessage={() => {
                          return messages.SELECT_LOADING;
                        }}
                        onChange={this.handleStoreChange}
                        value={this.state.selectedStore}
                        isDisabled={this.props.loadingStores}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
              <Col md="3">
                {this.state.selectedMonth && this.state.selectedYear ? (
                  <ExportCSV
                    disabled={this.state.loadingExport}
                    exportCSV={this.handleObtainSalesExport}
                    minWidth={layout.MD_MIN_WIDTH}
                  />
                ) : null}
              </Col>
            </Row>

            <hr className="my-4" />
            {this.state.showChart ? (
              <Row>
                <Col>
                  <Bar
                    data={charts.SellsByDayData(this.props.sellsByDayChartData)}
                    options={charts.SellsByDayOptions()}
                  />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">Seleccione un mes y año</Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { sellsByDay, total, error, loading } = state.dashboard.sellsByDayList;
  return {
    error,
    loading,
    _months: months,
    years: selectHelper.getYearsForSelect(),
    sellsByDayChartData: selectorChart.selectChartData(
      sellsByDay,
      "day",
      "total",
      formatHelper.toTwoDecimal,
      total
    ),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSellsByDay,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardSellsByDay);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByDay/CardSellsByDay.js